export const environment = {
  envName: 'stage',
  defaultLandingPage: 'map-search',
  googleAnalyticsMeasurementId: 'G-2Q5DWCXRXL',
  production: true,
  SERVICE_HOST: 'https://api-stage.mtnra.com',
  PREDICT_SERVICE_HOST:'https://pnc-stage-api.mtnra.com/predict',
  PREDICT_API_KEY : 'K7IOcZx8Vh5y8x7cVha5K9E0NbSPBHm277tbA6rc',
  GRADE_API_BASE_URL: 'https://cual6wiui7.execute-api.us-east-1.amazonaws.com/stage',
  GRADE_API_KEY: 'FNKyiHea0caVV6SMzeS4F7mJBIPCEKyc5uQMD8do',
  AUTH_CONFIG: {
    clientID: 'Gwjmiw2uP3K3OK4g1vLt63RPY28kG0sS',
    domain: 'stage-retailstat.us.auth0.com',
    callbackURL: 'https://insights-stage.mtnra.com/authenticating',
    logoutURL: 'https://insights-stage.mtnra.com/logout',
    clientSecret : 'xamufs5KBMDKvAu_ckZvbzd9Mpc0YwQUmruJqxSz2dhCgjsT-tREufLyAobtV0pk',
    MTNRAServiceUrl: 'https://stage-rs-ui.retailstat.com/api/services/mtn?relayState=https://insights-stage.mtnra.com/authenticating',
    RS_W_BASE_URL: 'https://stage-rs-ui.retailstat.com',
  },
  VERSION: require('../../package.json').version,
  GRAY_SCALE : '4214e56cca37bed7',
  GRAYSCALE_WITH_POI :'8fc4edfcb188f772',
  DARKTHEME : '4bbe431ce0178faa',
  DARKTHEME_WITH_POI : 'ab516a0641a8c292'
};
